import { render, staticRenderFns } from "./checkout-heading.vue?vue&type=template&id=508580cd&scoped=true&"
import script from "./checkout-heading.vue?vue&type=script&lang=js&"
export * from "./checkout-heading.vue?vue&type=script&lang=js&"
import style0 from "./checkout-heading.vue?vue&type=style&index=0&id=508580cd&lang=scss&scoped=true&"
import style1 from "./checkout-heading.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508580cd",
  null
  
)

export default component.exports